module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr-ca":{"Monthly":"Mensuelles","Annual":"Annuelles"}}')
  delete Component.options._Ctor
}
